import { render } from "./ImageAssetPopup.vue?vue&type=template&id=bde1da9c&scoped=true"
import script from "./ImageAssetPopup.vue?vue&type=script&lang=js"
export * from "./ImageAssetPopup.vue?vue&type=script&lang=js"

import "./ImageAssetPopup.vue?vue&type=style&index=0&id=bde1da9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde1da9c"]])

export default __exports__